import { createFileRoute } from '@tanstack/react-router';
import Shifts from 'src/pages/Organization/Event/Shifts';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/shifts',
)({
  component: Shifts,
});
